import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
import React from 'react';

export const BuildingLocationInBlock = ({
  values,
  handleChangeCaracObj,
  errors,
  touched
}) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Esquina' },
    { value: 2, label: 'Media Cuadra' }
  ];
  return (
    <div>
      <label>Ubicación del edificio en la cuadra </label>
      <ReactSelect
        name="buildingLocationInBlock"
        placeholder="-- Seleccione la ubicación en la cuadra --"
        options={options}
        value={options.find(v => v.value === values)}
        onChange={e => {
          handleChangeCaracObj(
            'buildingLocationInBlock',
            e?.value && Number(e.value)
          );
        }}
      />
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger">{errors.type}</label>
      )}
    </div>
  );
};

BuildingLocationInBlock.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
